module.exports = __webpack_public_path__ + "static/img/ajq1.d6b43df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ajq1.png
// module id = sjZo
// module chunks = 1